import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useNavigate } from 'react-router-dom';
import stevenProfile from "../../assets/images/steve_profile.jpg";
import dk_events from "../../assets/images/dk_events.jpg";
import the_grounds from "../../assets/images/the_grounds.jpg";
import dodejay_hair from "../../assets/images/dodejay_hair.jpg";
import InstagramModal from '../InstagramModal';
const responsive = {
  desktop: { breakpoint: { max: 3000, min: 1024 }, items: 2 },
  tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
  mobile: { breakpoint: { max: 464, min: 0 }, items: 1.5 },
};

const CarouselComponent = ({
  items,
  title
}) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState(null);
  const [isOpen,setIsOpen]=useState(false)

  const openModal = (item) => {
    setSelectedItem(item);
    setIsOpen(true)
  };

  const closeModal = () => {
    setSelectedItem(null);
    setIsOpen(false)
  };
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <>
    <InstagramModal
          isOpen={isOpen}
          onClose={closeModal}
          item={selectedItem}
        />
    <div
    className='mb-6'
    >
      
      <Carousel
        responsive={responsive}
        swipeable={true}
        draggable={true}
        showDots={false}
        infinite={false}
        autoPlay={false}
        keyBoardControl={true}
        transitionDuration={500}
        containerClass="carousel-container"
        itemClass="carousel-item-padding-40-px"
        arrows={isDesktop} 
      >
        {items.map((item, index) => (
  <div
    key={index}
    className="text-start pr-4 cursor-pointer"
    onClick={() => {
      console.log('item', item);
      openModal(item);
    }}
    style={{ position: 'relative', zIndex: 10 }}
  >
    {item.media[0]?.video ? (
      <video
        src={item.media[0]?.imgSrc}
        className="w-[380px] h-[370px] object-cover mb-1"
              autoPlay
              muted
              playsInline
              preload="metadata"
        style={{ pointerEvents: 'none' }}
      />
    ) : (
      <img
        src={item.media[0]?.imgSrc}
        alt={item.title}
        className="w-[380px] h-[370px] object-cover mb-1"
        style={{ pointerEvents: 'none' }}
      />
    )}
    <span>{item.description}</span>
  </div>
))}

      </Carousel>
<Link
              to="/turn-your-story-into-a-film"
              className={`mt-4 mx-auto bg-black text-white w-56  py-3 px-2 text-center transition-all duration-300 font-lato flex justify-center w-56 self-center`}
            >
              Book your film package
            </Link>
            <p className="w-full text-center mx-auto mt-1">Price:{' '}$3,500</p>
    </div></>
    
  );
};
const TurnYourStorySection = () => {
  return (
    <section>
      
      <CarouselComponent title='TRANSFORM YOUR STORY' 
        items={[
    {
      username: "steven_khalil",
      profileLink: "https://www.instagram.com/steven_khalil/",
      profilePicture:stevenProfile,
      caption: "People often assume I had a perfect upbringing, like I went to private schools or something, but the reality was far from that. My childhood was tough. My brother had a mental illness, which made life at home chaotic. He would blast music at all hours to drown out the voices in his head. My mum is still his carer. Growing up, I found my escape in creativity. I was drawn to things most kids weren’t, like fabrics and design. I would use old curtains to dress up the little girls in the neighbourhood. I was obsessed with Diana and Charles’ wedding. I was 6 at the time and Mum still remembers how excited I was. She didn’t fully understand, but she never stopped me. She would give me any fabric she could find, just to let me be creative. We didn’t have much growing up. She was a single parent, and we lived in government housing in Campbelltown. Life was hard, but I was a strong kid, and knowing I would get through it kept me going. Mum did her best. Back then, it was all about survival. If you were fed and clothed, that was success in her eyes. We didn’t talk much about feelings or dreams; it was more about getting through the day. I wanted to study fashion, but I couldn’t get into the fancy design schools. My aunt, a seamstress, said “why don’t you go do garment production at Bankstown TAFE”. It wasn’t the prestigious path I had imagined, but it was the right one for me. By 19, I was sewing dresses from my bedroom, and by 21, I became the head designer at a bridal boutique in Double Bay. It felt like destiny, even if it wasn’t the path I initially wanted. I’ve spent my life dressing women for their weddings, always aiming to make them feel special in their gowns. The fabric, the movement, the extravagance—that’s what drew me in. Mum is my biggest cheerleader. She tells everyone at the supermarket, “Steven Kahlil is my son!” She saw my hard work, even if she didn’t always know how to encourage it. Looking back, I realise nothing in my life was meant to be easy. But I wouldn’t change a thing. It’s made me who I am today. I’m grateful for the gift I have, the people around me, and the chance to do what I love.",
      media: [{
        imgSrc: 'https://melo-story.s3.eu-north-1.amazonaws.com/MeloStories/video.mp4',
      video: true
      }],
      likes:'4,207',
      comments:'386',
      shares:'765'
      
    },
    {
      username: "dianekhoury",
      profileLink: "https://www.instagram.com/dianekhouryweddingsandevents/",
      profilePicture:dk_events,
      caption: "They don’t make them like that anymore. Mum gave up everything for us. I could never be like her. She had a role in the house, and that’s how we were brought up. From a young age, she instilled the value of faith in me. You know, I always worked and supported myself so my parents wouldn’t have to worry. They struggled, and paying bills was always an open discussion at home. As a teen, I enjoyed my retail job, where I styled customers. I loved helping others and making them feel good. After graduating, I worked as an accountant but missed connecting with people. So, when I started to plan my wedding, I fell in love with the process. My wedding was beautiful, and people started asking me to plan their weddings too. I thought, “I’m actually good at this. This could be a career.” And that’s how it all started. Though I had a promising career, leaving my job was scary. But my husband was my biggest supporter. He told me, “take a risk.” So I did. I worked hard and gained confidence. With each event, I realised, “You got this, girl,” and I went full steam ahead. Having children brought new challenges. Balancing work and motherhood wasn’t easy. There were times I wanted to give up, especially when COVID hit. I lost a huge overseas life-changing opportunity. I felt like I had no control. But looking back, God had a plan. During the time off, I remember falling asleep on the couch and waking up not feeling like myself. Turns out, I was pregnant! My two boys were conceived with difficulty, and then my daughter Faith came naturally. That was a huge moment. She was a blessing. That’s why the gender reveal was emotional for me. Seeing that pink was a reminder to trust the process. If I’d taken that job, I would’ve missed this chance. Now, I stress less about the little things. I breathe, pray, and focus on what really matters. My business has evolved into a trusted brand. It’s amazing to connect with clients and create something special together. For me, success is about making a positive impact on people’s lives. My mum’s selflessness and values have shaped who I am. She always says, “Be humble and thank God for what you’ve got.” That’s what I strive to live by every day",
      media: [{
        imgSrc: 'https://melo-story.s3.eu-north-1.amazonaws.com/DK+Weddings+%26+Events/PART+1+(1).mp4',
      video: true
      }],
      likes:'2,925',
      comments:'207',
      shares:'216'
    },
    {
      username: "thegrounds",
      profileLink: "https://www.instagram.com/thegrounds/",
      profilePicture:the_grounds,
      caption: "My father used to say, “You’ve got to be hungry,” and back then, I didn’t fully understand what he meant. However, it’s clear to me now as I try to live by that extra 1%, a principle I witnessed firsthand growing up while observing him in his businesses. When he passed away, it was definitely one of my biggest life lessons. I learned to adapt. You know, you either go left or you go right, and I chose to go forward. He actually operated a warehouse just two doors down from The Grounds, and just like my son comes into my office, as a kid, I spent most of my time with him. Though I occasionally felt bored, those moments served as valuable lessons. Those early experiences really lit a fire in me to build something of my own. I knew that something needed to be offered in Alexandria. I wanted to create a place that people could enjoy and experience. I was very lucky to be given a chance to build here. It was scary. I was so scared, especially because it was out of my comfort zone. The loss of my father taught me the importance of resilience and constant self-improvement, principles I now incorporate as we continue to grow The Grounds. Keeping our family values intact and pushing through, The Grounds has evolved into our sanctuary—a place to reflect on childhood memories, emphasising togetherness, connection, and joy, which form the essence and core of what The Grounds represents. Witnessing its growth from that initial small cafe into the thriving community space today is truly incredible. This journey wouldn’t have been possible without the amazing team around me, particularly Therese. She has been a huge part of our success through her incredible creativity and vision. She’s been there through all the highs and lows, helping to keep me stable, especially during the really tough times. Therese has such an amazing eye for creating experiences that make The Grounds feel truly special. It’s a big reason why people keep coming back and why we’ve been able to grow the way we have. At this point, The Grounds really does feel like our baby that we’ve built together.",
      media: [{
        imgSrc: 'https://melo-story.s3.eu-north-1.amazonaws.com/The+Grounds+of+Alexandria/Grounds%2BRevision%2B(1).mp4',
      video: true
      }],
      likes:'909',
      comments:'63',
      shares:'181'
      
    },
    {
      username: "dodiejayhair",
      profileLink: "https://www.instagram.com/dodiejayhair/",
      profilePicture:dodejay_hair,
      caption: "When she looked at me. She just knew what I was going through. She told me that, regardless of what might happen over the coming period, whenever I looked at myself, my eyes would be the first thing I’d see. I lost my hair and my weight. I couldn't even recognise myself in the mirror. At 23, I honestly thought I was invincible. Things were really taking off for me. I was doing bridal hair alongside my mentor, Natalie Anne, appearing on TV shows, and travelling all over for work. I definitely had a lot of signs to slow down and to take care of myself, even as symptoms started to appear, like headaches and swelling, I disregarded them. I never wanted to let down my clients, especially those I had built relationships with over the years. But everything changed when I was diagnosed with stage four blood cancer. I'll never forget that moment - sitting in the doctor's room. He was careful not to use the 'C' word. At first, he was speaking medical jargon. And It weighed on me. I was like, 'Are you talking about chemotherapy?' He responded, 'Yes.' I went silent. I didn't cry; I just sat there frozen. He came close to my face, shook me and said, 'Today I tell you that my daughter has been diagnosed with cancer, and I will treat you no differently.' Recovering was hard. It was a long mental struggle to rebuild myself and feel normal again. I had to mourn the person I was. As I recovered, I was able to develop a stronger sense of self-worth based on who I was as a person rather than how I looked. So, when I first opened my salon, it was such an inspiring time for me. I really wanted to create a space where people could feel limitless - somewhere they could truly flourish and grow both physically and internally. For me, hair is all about transformations - changing how people look and how they feel about themselves. I wanted my clients to leave feeling confident and with a boosted sense of self. Rebuilding my dreams and driving my own business helped me rebuild myself. This salon is an extension of who I am, and being able to create this space where people can freely grow really reignited that fire in me.",
      media: [{
        imgSrc: 'https://melo-story.s3.eu-north-1.amazonaws.com/Dodie+Jay+Hair/Dodie+-+Draft+4+-+Reel+Format+(1)+(1).mp4',
      video: true
      }],
      likes:'2,101',
      comments:'245',
      shares:'137'
      
    },
    
    
  ]}
      />
    </section>
  );
};

export default TurnYourStorySection;
